import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft } from "@fortawesome/pro-regular-svg-icons/faAngleLeft";
import { faAngleRight } from "@fortawesome/pro-regular-svg-icons/faAngleRight";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { faArrowUp } from "@fortawesome/pro-regular-svg-icons/faArrowUp";
import { faAt } from "@fortawesome/pro-regular-svg-icons/faAt";
import { faUserAstronaut } from "@fortawesome/pro-regular-svg-icons/faUserAstronaut";
import { faBars } from "@fortawesome/pro-regular-svg-icons/faBars";
import { faBell } from "@fortawesome/pro-regular-svg-icons/faBell";
import { faBook } from "@fortawesome/pro-regular-svg-icons/faBook";
import { faBriefcase } from "@fortawesome/pro-regular-svg-icons/faBriefcase";
import { faBullhorn } from "@fortawesome/pro-regular-svg-icons/faBullhorn";
import { faBuilding } from "@fortawesome/pro-regular-svg-icons/faBuilding";
import { faCalendarDays } from "@fortawesome/pro-regular-svg-icons/faCalendarDays";
import { faChartLine } from "@fortawesome/pro-regular-svg-icons/faChartLine";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faCircle } from "@fortawesome/pro-regular-svg-icons/faCircle";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleXmark } from "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons/faChevronUp";
import { faChevronsDown } from "@fortawesome/pro-regular-svg-icons/faChevronsDown";
import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons/faCircleNotch";
import { faClipboardCheck } from "@fortawesome/pro-regular-svg-icons/faClipboardCheck";
import { faEuroSign } from "@fortawesome/pro-regular-svg-icons/faEuroSign";
import { faMartiniGlassCitrus } from "@fortawesome/pro-regular-svg-icons/faMartiniGlassCitrus";
import { faCoins } from "@fortawesome/pro-regular-svg-icons/faCoins";
import { faDollarCircle } from "@fortawesome/pro-regular-svg-icons/faDollarCircle";
import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons/faEllipsis";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { faArrowRightArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowRightArrowLeft";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons/faTriangleExclamation";
import { faGavel } from "@fortawesome/pro-regular-svg-icons/faGavel";
import { faGear } from "@fortawesome/pro-regular-svg-icons/faGear";
import { faGlobe } from "@fortawesome/pro-regular-svg-icons/faGlobe";
import { faHandshake } from "@fortawesome/pro-regular-svg-icons/faHandshake";
import { faHouse } from "@fortawesome/pro-regular-svg-icons/faHouse";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faLifeRing } from "@fortawesome/pro-regular-svg-icons/faLifeRing";
import { faLink } from "@fortawesome/pro-regular-svg-icons/faLink";
import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faLockKeyhole } from "@fortawesome/pro-regular-svg-icons/faLockKeyhole";
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons/faLocationDot";
import { faMobile } from "@fortawesome/pro-regular-svg-icons/faMobile";
import { faPercent } from "@fortawesome/pro-regular-svg-icons/faPercent";
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faPlay } from "@fortawesome/pro-regular-svg-icons/faPlay";
import { faPhone } from "@fortawesome/pro-regular-svg-icons/faPhone";
import { faPlus } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faPowerOff } from "@fortawesome/pro-regular-svg-icons/faPowerOff";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import { faRetweet } from "@fortawesome/pro-regular-svg-icons/faRetweet";
import { faRocket } from "@fortawesome/pro-regular-svg-icons/faRocket";
import { faRocketLaunch } from "@fortawesome/pro-regular-svg-icons/faRocketLaunch";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { faFileMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faFileMagnifyingGlass";
import { faShieldCheck } from "@fortawesome/pro-regular-svg-icons/faShieldCheck";
import { faTruckFast } from "@fortawesome/pro-regular-svg-icons/faTruckFast";
import { faFaceSmile } from "@fortawesome/pro-regular-svg-icons/faFaceSmile";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons/faSpinner";
import { faStar } from "@fortawesome/pro-regular-svg-icons/faStar";
import { faSuitcase } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faGaugeMax } from "@fortawesome/pro-regular-svg-icons/faGaugeMax";
import { faTag } from "@fortawesome/pro-regular-svg-icons/faTag";
import { faXmark } from "@fortawesome/pro-regular-svg-icons/faXmark";
import { faTrophy } from "@fortawesome/pro-regular-svg-icons/faTrophy";
import { faUnlockKeyhole } from "@fortawesome/pro-regular-svg-icons/faUnlockKeyhole";
import { faUser } from "@fortawesome/pro-regular-svg-icons/faUser";
import { faUsers } from "@fortawesome/pro-regular-svg-icons/faUsers";
import { faCircleUser } from "@fortawesome/pro-regular-svg-icons/faCircleUser";
import { faAddressCard } from "@fortawesome/pro-regular-svg-icons/faAddressCard";
import { faStar as faSolidStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faMessageQuote } from "@fortawesome/pro-solid-svg-icons/faMessageQuote";
import { faLocationDot as faLocationDotSolid } from "@fortawesome/pro-solid-svg-icons/faLocationDot";
import { faCircleCheck as faCircleCheckSolid } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faImage } from "@fortawesome/pro-regular-svg-icons/faImage";
import { faCreditCard } from "@fortawesome/pro-regular-svg-icons/faCreditCard";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";

// We are only using the user-astronaut icon
library.add(
  faAddressCard,
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faArrowLeft,
  faArrowUp,
  faAt,
  faUserAstronaut,
  faBars,
  faBell,
  faBook,
  faBriefcase,
  faBullhorn,
  faFileMagnifyingGlass,
  faBuilding,
  faCalendarDays,
  faChartLine,
  faCheck,
  faCircle,
  faCircleCheck,
  faCircleXmark,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronsDown,
  faCircleNotch,
  faClipboardCheck,
  faEuroSign,
  faMartiniGlassCitrus,
  faCoins,
  faCopy,
  faEllipsis,
  faEnvelope,
  faArrowRightArrowLeft,
  faCircleExclamation,
  faTriangleExclamation,
  faGavel,
  faGear,
  faGlobe,
  faHandshake,
  faHouse,
  faCircleInfo,
  faLifeRing,
  faLink,
  faLock,
  faLockKeyhole,
  faLocationDot,
  faMobile,
  faPercent,
  faPaperPlane,
  faPlay,
  faPhone,
  faPlus,
  faPowerOff,
  faCircleQuestion,
  faRetweet,
  faRocket,
  faRocketLaunch,
  faMagnifyingGlass,
  faShieldCheck,
  faTruckFast,
  faFaceSmile,
  faSpinner,
  faStar,
  faSuitcase,
  faGaugeMax,
  faTag,
  faXmark,
  faTrophy,
  faUnlockKeyhole,
  faUser,
  faUsers,
  faCircleUser,
  faSolidStar,
  faDollarCircle,
  faMessageQuote,
  faLocationDotSolid,
  faCircleCheckSolid,
  faImage,
  faCreditCard,
  faEye,
  faEyeSlash
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.i2svg();
dom.watch();
